import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) => ({
  container: {
    padding: theme.spacing(3),
    paddingTop: '103px',
    maxWidth: '1200px',
    margin: '0 auto',
    minHeight: '100vh',
    backgroundColor: STYLE.COLOR.WHITE,
    '@media (max-width: 1024px)': {
      paddingTop: '100px',
      maxWidth: '100%',
      padding: theme.spacing(2),
    },
    '@media (max-width: 768px)': {
      paddingTop: '90px',
      padding: theme.spacing(2),
    },
    '@media (max-width: 600px)': {
      paddingTop: '80px',
    },
    '@media (max-width: 480px)': {
      padding: theme.spacing(2),
      paddingTop: '90px',
    },
  },
  containerWithWarning: {
    paddingTop: '143px',
    '@media (max-width: 1024px)': {
      paddingTop: '140px',
    },
    '@media (max-width: 768px)': {
      paddingTop: '130px',
    },
    '@media (max-width: 600px)': {
      paddingTop: '120px',
    },
    '@media (max-width: 480px)': {
      paddingTop: '130px',
    },
  },
  mainHeader: { left: 0 },

  // Header styles
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(4),
    '@media (max-width: 768px)': {
      marginBottom: theme.spacing(3),
    },
    // paddingBottom: theme.spacing(2),
  },
  title: {
    fontWeight: 600,
    color: STYLE.COLOR.BLACK,
    fontSize: '32px',
    lineHeight: '39px',
    '@media (max-width: 768px)': {
      fontSize: '24px',
      lineHeight: '30px',
    },
    '@media (max-width: 480px)': {
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
  headerActions: {
    display: 'flex',
    gap: theme.spacing(2),
    '@media (max-width: 768px)': {
      width: '100%',
      justifyContent: 'flex-start',
    },
    '@media (max-width: 480px)': {
      gap: theme.spacing(1.5),
    },
  },
  actionButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  actionButton: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    textDecoration: 'underline',
    color: STYLE.COLOR.ACCENT_PRIMARY,
    cursor: 'pointer',
  },

  // Tabs styles
  tabsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '32px',
    gap: theme.spacing(2),
    '@media (max-width: 960px)': {
      marginBottom: theme.spacing(3),
    },
    '@media (max-width: 480px)': {
      gap: '10px',
    },
  },
  tabs: {
    borderBottom: '0px' + '!important',
    '& .MuiTab-root': {
      textTransform: 'none',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '24px',
      color: STYLE.COLOR.TEXT1,
      '&.Mui-selected': {
        backgroundColor: STYLE.COLOR.ACCENT_PRIMARY,
        color: STYLE.COLOR.WHITE,
        '& .custom-count-badge': {
          backgroundColor: STYLE.COLOR.ACCENT_PRIMARY_LIGHTER3,
          color: STYLE.COLOR.ACCENT_PRIMARY,
        },
      },
      '@media (max-width: 768px)': {
        fontSize: '14px',
        minWidth: 'auto',
        padding: theme.spacing(1, 1.5),
      },
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
    '@media (max-width: 768px)': {
      width: '100%',
      '& .MuiTabs-flexContainer': {
        justifyContent: 'flex-start',
      },
    },
    '@media (max-width: 480px)': {
      overflowX: 'auto',
      '& .MuiTabs-scroller': {
        overflowX: 'auto !important',
      },
    },
  },
  tab: {
    border: `1px solid ${STYLE.COLOR.STROKE_DEFAULT}` + '!important',
    borderRadius: '8px !important',
    marginRight: '16px' + '!important',
    '@media (max-width: 768px)': {
      marginRight: '8px' + '!important',
    },
    '@media (max-width: 480px)': {
      marginRight: '6px' + '!important',
    },
  },
  customTabLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  customCountBadge: {
    backgroundColor: STYLE.COLOR.ACCENT_PRIMARY_LIGHTER3,
    color: STYLE.COLOR.ACCENT_PRIMARY,
    borderRadius: '50%',
    minWidth: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '10px',
    fontWeight: 600,
    lineHeight: 1,
  },
  sortButton: {
    width: '112px' + '!important',
    height: '52px' + '!important',
    opacity: 1,
    border: `1px solid ${STYLE.COLOR.STROKE_DEFAULT}` + '!important',
    borderRadius: '52px' + '!important',
    padding: '14px 24px' + '!important',
    fontSize: '16px' + '!important',
    fontWeight: 400 + '!important',
    lineHeight: '24px' + '!important',
    color: STYLE.COLOR.TEXT1 + '!important',
    // gap: '8px' + '!important',
    display: 'flex' + '!important',
    alignItems: 'center' + '!important',
    flexShrink: 0 + '!important',
    '@media (max-width: 960px)': {
      justifyContent: 'center !important',
      minWidth: '52px !important',
      padding: '0 !important',
      '& svg': {
        margin: 0 + '!important',
      },
    },
    '@media (max-width: 480px)': {
      height: '44px !important',
      width: '44px !important',
      minWidth: '44px !important',
      borderRadius: '12px' + '!important',
    },
  },

  // Projects grid
  projectsGrid: {
    marginTop: theme.spacing(2),
    '@media (max-width: 768px)': {
      '& > .MuiGrid-item': {
        paddingTop: '18px !important',
      },
    },
    '@media (max-width: 480px)': {
      '& > .MuiGrid-item': {
        paddingTop: '18px !important',
      },
    },
  },

  // Status columns layout

  columnContent: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: STYLE.COLOR.BOX_SHADOW,
    borderRadius: '12px',
    padding: '12px 12px',
    position: 'relative',
  },

  columnHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    marginBottom: '26px',
    '@media (min-width: 960px)': {
      cursor: 'default',
      pointerEvents: 'none',
    },
  },

  columnHeaderCollapsed: {
    marginBottom: 0,
    '@media (min-width: 960px)': {
      marginBottom: '26px',
    },
  },

  columnHeaderIcon: {
    fontSize: '20px',
    transition: 'transform 0.3s',
    color: STYLE.COLOR.TEXT1,
    display: 'block',
    '@media (min-width: 960px)': {
      display: 'none !important',
    },
  },

  columnHeaderIconExpanded: {
    transform: 'rotate(180deg)',
  },

  columnTag: {
    width: 120,
    height: 22,
    gap: 12,
    borderRadius: 4,
    padding: '2px 8px',
    backgroundColor: STYLE.COLOR.WARNING,
  },
  columnTagText: {
    color: STYLE.COLOR.WHITE,
    fontSize: 10,
    fontWeight: 600,
    lineHeight: '18px',
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  columnProjectsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '26px',
  },
  columnProjectCard: {
    width: '100%',
  },
  noProjectsText: {
    color: STYLE.COLOR.TEXT2,
    fontSize: '14px',
    lineHeight: '20px',
    textAlign: 'center',
  },

  // Project card styles
  projectCard: {
    opacity: 1,
    gap: '16px',
    borderRadius: '12px' + '!important',
    borderWidth: '1px',
    border: '1px solid #EAEAEA',
    boxShadow: '0 16px 20px -8px rgba(228, 231, 233, 0.40)' + '!important',
  },

  menuButton: {
    color: STYLE.COLOR.ACCENT_PRIMARY + '!important',
    padding: theme.spacing(0.5),
    borderWidth: '1px',
  },

  // Project info styles
  projectInfo: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'row',
    marginTop: theme.spacing(1.3),
    justifyContent: 'space-between',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(1.5),
  },
  avatarContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  projectAvatar: {
    backgroundColor: STYLE.COLOR.WARNING_LIGHT + '!important',
    color: STYLE.COLOR.TEXT4 + '!important',
    width: '40px',
    height: '40px',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  projectName: {
    fontSize: '14px',
    fontWeight: 500,
    color: STYLE.COLOR.TEXT1,
    lineHeight: '24px',
    marginLeft: theme.spacing(1),
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '200px',
    '@media (max-width: 768px)': {
      maxWidth: '150px',
    },
    '@media (max-width: 480px)': {
      maxWidth: '120px',
    },
  },
  companiesContainer: {
    borderTop: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
    borderTopStyle: 'dashed',
    margin: '16px',
  },
  companiesText: {
    marginTop: '16px',
    color: STYLE.COLOR.TEXT2,
    fontSize: '14px',
    lineHeight: '20px',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textAlign: 'left',
    height: 44,
  },
  viewMissingRequirementsLink: {
    display: 'block',
    marginTop: '8px',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    textDecoration: 'underline',
    textDecorationStyle: 'solid',
    color: STYLE.COLOR.ERROR,
    cursor: 'pointer',
  },
  statusContainer: {
    height: 22,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  projectStatusText: {
    fontSize: 10,
    fontWeight: 600,
    lineHeight: '16px',
    textAlign: 'center',
    textTransform: 'uppercase',
    padding: '3px 8px',
    borderRadius: '4px 0px 0px 4px',
  },

  // Context Menu styles
  contextMenu: {
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
      borderRadius: theme.spacing(1),
      minWidth: '200px',
      padding: '0px 12px',
    },
  },
  sortMenu: {
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: `1px solid ${STYLE.COLOR.STROKE_DEFAULT}`,
      borderRadius: theme.spacing(1),
      minWidth: '200px',
      padding: '0px 12px',
      marginTop: '12px',
    },
  },
  menuItem: {
    padding: '8px 8px 8px 6px' + '!important',
    fontSize: '14px' + '!important',
    fontWeight: 400,
    lineHeight: '20px' + '!important',
    color: STYLE.COLOR.TEXT1 + '!important',
    '&:hover, &.Mui-selected': {
      backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT + '!important',
      borderRadius: theme.spacing(1) + '!important',
    },
    '& svg': {
      marginRight: '8px',
      fontSize: '18px',
      color: STYLE.COLOR.TEXT2,
      width: '18px',
      height: '18px',
    },
  },

  // Empty state styles
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(8, 2),
    textAlign: 'center',
    minHeight: '400px',
  },
  emptyStateIcon: {
    fontSize: '64px',
    marginBottom: theme.spacing(2),
    opacity: 0.5,
  },
  emptyStateTitle: {
    fontWeight: 600,
    color: STYLE.COLOR.TEXT1,
    marginBottom: theme.spacing(1) + '!important',
  },
  emptyStateSubtitle: {
    color: STYLE.COLOR.TEXT2,
    maxWidth: '400px',
  },
  content: {
    paddingBottom: theme.spacing(2),
  },
  paginationWrapper: {
    padding: theme.spacing(2, 0),
    marginTop: '48px',
    marginBottom: '48px',
    '@media (max-width: 768px)': {
      marginTop: '32px',
      marginBottom: '32px',
    },
    '@media (max-width: 480px)': {
      marginTop: '24px',
      marginBottom: '24px',
      '& .MuiPagination-ul': {
        flexWrap: 'nowrap',
        justifyContent: 'center',
      },
    },
  },

  // Dropdown styles for mobile
  tabDropdown: {
    flex: 1 + '!important',
    border: `1px solid ${STYLE.COLOR.STROKE_DEFAULT}` + '!important',
    borderRadius: '12px' + '!important',
    justifyContent: 'space-between' + '!important',
    padding: '14px 16px' + '!important',
    color: STYLE.COLOR.TEXT1 + '!important',
    fontWeight: 500 + '!important',
    fontSize: '14px' + '!important',
    lineHeight: '100%' + '!important',
  },

  dropdownMenu: {
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
      borderRadius: theme.spacing(1),
      minWidth: `calc(100% - 88px)`,
      padding: '0px 12px',
      marginTop: '8px',
    },
  },

  dropdownMenuItem: {
    fontSize: '14px' + '!important',
    fontWeight: 400,
    lineHeight: '20px' + '!important',
    color: STYLE.COLOR.TEXT1 + '!important',
    minHeight: '36px' + '!important',
    paddingLeft: '8px' + '!important',
    '&:hover, &.Mui-selected': {
      backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT + '!important',
      borderRadius: theme.spacing(1) + '!important',
    },
    '& svg': {
      marginRight: '8px',
      fontSize: '18px',
      color: STYLE.COLOR.TEXT2,
      width: '18px',
      height: '18px',
    },
  },
  dropdownItemContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    // gap: theme.spacing(1),
  },
  dropdownCountBadge: {
    backgroundColor: STYLE.COLOR.ACCENT_PRIMARY_LIGHTER3,
    color: STYLE.COLOR.ACCENT_PRIMARY,
    borderRadius: '50%',
    minWidth: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '10px',
    fontWeight: 600,
    lineHeight: 1,
  },

  // Modal styles
  modalContent: {
    padding: '24px',
    minWidth: '600px',
    minHeight: '300px',
    '@media (max-width: 480px)': {
      padding: '16px',
      minWidth: '300px',
    },
  },
  modalContentNoPadding: {
    padding: '0px !important',
  },

  modal: {
    '& .MuiDialog-paper': {
      width: '560px',
      maxWidth: '100%',
    },
  },
  modalTitle: {
    justifyContent: 'flex-end',
    paddingBottom: '0px !important',
  },
  confirmationModalContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    borderWidth: '0px',
    paddingTop: '0px !important',
    paddingBottom: '16px !important',
    marginTop: -12,
  },
  modalActions: {
    borderWidth: '0px',
    justifyContent: 'center !important',
    paddingBottom: '32px !important',
  },
  imageParent: {
    height: 90,
    width: 90,
  },
  button: {
    minWidth: '140px !important',
  },
  warningTitle: {
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: '28px',
    color: STYLE.COLOR.TEXT1,
    textAlign: 'center',
    marginTop: 32,
    marginBottom: 12,
  },
  warningText: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '26px',
    color: STYLE.COLOR.TEXT1,
  },
  companyNames: {
    color: STYLE.COLOR.ACCENT_PRIMARY,
  },

  // Loading and error state styles
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '40px',
  },
  errorContainer: {
    padding: '20px',
  },
}));
